import ApiAcces from "@/shared/services/ApiAcces";
import type Page from "@/shared/models/Page";
import type PageRequest from "@/shared/models/PageRequest";
import type IIntegrationProvider from "../contracts/IIntegrationProvider";
import type IntegrationProvider from "../models/integrationProvider";

export default class IntegrationProvidesService
  extends ApiAcces
  implements IIntegrationProvider
{
  async get(id: string): Promise<IntegrationProvider> {
    return (await this.api.get(`api/integrations/providers/${id}`)).data;
  }

  async getAll(pageRequest: PageRequest): Promise<Page<IntegrationProvider>> {
    return (
      await this.api.get("api/integrations/providers", { params: pageRequest })
    ).data;
  }

  async create(
    provider: Omit<IntegrationProvider, "id">,
  ): Promise<IntegrationProvider> {
    return (await this.api.post("api/integrations/providers", provider)).data;
  }

  async update(
    id: string,
    provider: Partial<IntegrationProvider>,
  ): Promise<IntegrationProvider> {
    return (await this.api.patch(`api/integrations/providers/${id}`, provider))
      .data;
  }

  async delete(id: string): Promise<void> {
    await this.api.delete(`api/integrations/providers/${id}`);
  }
}
